"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsTab = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/patients/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const react_1 = require("react");
const React = require("react");
const edit_patient_1 = require("../../components/edit-patient");
const dummyPatient = {
    address: "",
    address2: "",
    birthDate: "",
    city: "",
    email: "",
    firstName: "",
    gender: "",
    id: 0,
    lastName: "",
    middleName: "",
    phone: "",
    state: "",
    zip: ""
};
let DetailsTab = class DetailsTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.confirmDeletePatient = null;
        this.confirmUndeletePatient = null;
        this.patient = ramda_1.merge(dummyPatient, {});
        this.onCancelEditPatient = () => {
            if (this.siteId) {
                router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/patients`);
            }
            else {
                router_1.RouteManager.transitionTo("/patients");
            }
        };
        this.onHandleClickDeletePatient = (patient) => {
            this.confirmDeletePatient = patient;
        };
        this.onHandleClickUndeletePatient = (patient) => {
            this.confirmUndeletePatient = patient;
        };
        this.onHandleClickConfirmDeletePatient = async () => {
            if (this.confirmDeletePatient) {
                const success = await store_1.patientsStore.deletePatient(this.confirmDeletePatient);
                if (success) {
                    router_1.RouteManager.transitionTo("/patients");
                }
                this.confirmDeletePatient = null;
            }
        };
        this.onHandleClickConfirmUndeletePatient = async () => {
            if (this.confirmUndeletePatient) {
                const success = await store_1.patientsStore.undeletePatient(this.confirmUndeletePatient);
                if (success) {
                    router_1.RouteManager.transitionTo("/patients");
                }
                this.confirmUndeletePatient = null;
            }
        };
        this.onHandleClickCancelDeletePatient = () => {
            this.confirmDeletePatient = null;
        };
        this.onHandleClickCancelUndeletePatient = () => {
            this.confirmUndeletePatient = null;
        };
        /** Modded to include insurance if insurance was submitted with the patient. */
        this.onSaveEditPatient = async (patient, insurance) => {
            // console.log("patient ---", patient);
            // console.log("insurance ---", insurance);
            this.patient = patient;
            if (patient.id) {
                await store_1.patientsStore.savePatient(patient, insurance !== null && insurance !== void 0 ? insurance : null);
            }
            else {
                const newPatient = insurance
                    ? await store_1.patientsStore.createPatient(patient, false, insurance)
                    : await store_1.patientsStore.createPatient(patient);
                if (newPatient) {
                    // E-075.1
                    // if (this.siteId) {
                    //   RouteManager.transitionTo(`/pharmacies/${this.siteId}/patients`);
                    // } else {
                    //   RouteManager.transitionTo(`/patients/${newPatient.id}`);
                    // }
                    router_1.RouteManager.transitionTo(`/patients/${newPatient.id}`);
                }
            }
        };
    }
    componentWillMount() {
        this.siteId =
            this.props.params.length === 2 ? Number(this.props.params[1]) : 0;
    }
    // public onMergePatient = async () => {
    // }
    render() {
        const patientId = Number(this.props.params[0]);
        return (React.createElement("div", { className: "patients__form" },
            React.createElement(edit_patient_1.EditPatient, { error: store_1.patientsStore.patient.error, warning: store_1.patientsStore.patient.value &&
                    store_1.patientsStore.patient.value.missingInsurance, loading: store_1.patientsStore.patient.loading, status: store_1.patientsStore.patient.status, onCancel: this.onCancelEditPatient, onSave: this.onSaveEditPatient, patient: patientId ? store_1.patientsStore.patient.value : this.patient, defaultSite: !patientId ? store_2.sitesDetailStore.site.value : undefined, onDelete: this.onHandleClickDeletePatient, onUndelete: this.onHandleClickUndeletePatient }),
            this.confirmDeletePatient && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm and continue", cancelText: "Cancel and go back", message: `Are you sure you want to delete ${this.confirmDeletePatient.firstName} ${this.confirmDeletePatient.lastName}?`, onCancel: this.onHandleClickCancelDeletePatient, onConfirm: this.onHandleClickConfirmDeletePatient, title: "Are you sure you want to proceed?" })),
            this.confirmUndeletePatient && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm and continue", cancelText: "Cancel and go back", message: `Are you sure you want to recover ${this.confirmUndeletePatient.firstName} ${this.confirmUndeletePatient.lastName}?`, onCancel: this.onHandleClickCancelUndeletePatient, onConfirm: this.onHandleClickConfirmUndeletePatient, title: "Are you sure you want to proceed?" }))));
    }
};
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "confirmDeletePatient", void 0);
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "confirmUndeletePatient", void 0);
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "patient", void 0);
DetailsTab = __decorate([
    mobx_react_1.observer
], DetailsTab);
exports.DetailsTab = DetailsTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/tabs/details/details.tsx
// module id = 3805
// module chunks = 0